<template>
	
	<div class="page-container">
    <md-app md-mode="reveal">
      <md-app-toolbar class="md-primary">
        <!--<md-button class="md-icon-button" @click="menuVisible = !menuVisible">
          <md-icon>menu</md-icon>
        </md-button>-->
        <span class="md-title">SDK管理后台(Mobile版)</span>
      </md-app-toolbar>

      <md-app-drawer :md-active.sync="menuVisible">
        <md-toolbar class="md-transparent" md-elevation="0">菜单</md-toolbar>

        <md-list>
          <md-list-item>
          
            <md-icon>move_to_inbox</md-icon>
            <span class="md-list-item-text"><a href="/#/product/index">产品列表</a></span>
          
          </md-list-item>
		  
		   <md-list-item>
            <md-icon>send</md-icon>
            <span class="md-list-item-text"><a href="/#/space/index">广告位</a></span>
          </md-list-item>

          <md-list-item>
            <md-icon>send</md-icon>
            <span class="md-list-item-text"><a href="/#/plan/index">广告投放</a></span>
          </md-list-item>

          <md-list-item>
            <md-icon>delete</md-icon>
            <span class="md-list-item-text">屏蔽策略</span>
          </md-list-item>

          <md-list-item>
            <md-icon>error</md-icon>
            <span class="md-list-item-text">扣量策略</span>
          </md-list-item>
        </md-list>
      </md-app-drawer>

      <md-app-content>
        <transition name="fade" mode="out-in">
            
              	<router-view ref="myMain"></router-view>
       
   			</transition>
      </md-app-content>
    </md-app>
  </div>

</template>

<script>
import { smenu, sconfig, swxapp, slist, splist, scpwd } from "../api/api";
export default {
  name: 'Home',
  data() {
  	  return{
  	  	 menuVisible: false
  	  }
	   
	  },
	  methods:{
	  	
	  },
	  mounted() {
	  	var that = this;
	    this.dpath = this.$route.path;
	    if (this.$cookie.getCookie("user")) {
	      this.uName = this.$cookie.getCookie("user");
	    }
	  	//获取配置文件
	    sconfig(this.$cookie.getCookie("login")).then(res => {
	      if (res.code == 200) {
	        this.$store.config = res.data;
	      }
	    });
	    smenu(this.$cookie.getCookie("login")).then(res => {
	      if (res.code == 200) {
	        this.menu = res.data;
	      }
	    });
	
	    swxapp("kw=", this.$cookie.getCookie("login")).then(res => {
	      if (res.code == 200) {
	        this.$store.applist = res.data;
	      }
	    });
	    slist("page=1&perpage=100", this.$cookie.getCookie("login")).then(res => {
	      if (res.code == 200) {
	        var arr = [];
	        res.data.list.forEach(v => {
	          arr.push({ id: v.id, name: v.version });
	        });
	        this.$store.vlist = arr;
	      }
	    });
	    splist("page=1&perpage=1000", this.$cookie.getCookie("login")).then(res => {
	      if (res.code == 200) {
	        // var arr=[];
	        // res.data.list.forEach(v=>{
	        //   arr.push({id:v.id,name:v.name})
	        // })
	        this.$store.plist = res.data.list;
	      }
	    });
	  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .md-app {

    border: 1px solid rgba(#000, .12);
  }

   // Demo purposes only
  .md-drawer {
    width: 230px;
    max-width: calc(100vw - 125px);
  }

</style>

<style type="text/css">
	.md-app-container{
	  overflow:inherit;
	  
	}
</style>



// WEBPACK FOOTER //
// Home.vue?462a0f46